import { render, staticRenderFns } from "./SolePropA.vue?vue&type=template&id=483743f2&scoped=true"
import script from "./SolePropA.vue?vue&type=script&lang=js"
export * from "./SolePropA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483743f2",
  null
  
)

export default component.exports